import { useCallback, useState } from 'react'
import { Token } from '../models/app'

interface StateProps {
  startIndex: number
  limit: number
  nextToken: Token
  nextNextToken: Token
  previousTokens: Token[]

  moveForward: boolean
}

const buildInitialState = (limit: number): StateProps => ({
  startIndex: 0,
  limit,
  nextToken: null,
  nextNextToken: null,
  previousTokens: [],

  moveForward: true,
})

const usePaginate = (initialLimit: number = 10) => {
  const [state, setState] = useState(() => buildInitialState(initialLimit))
  const { previousTokens } = state

  const jumpTo = useCallback((startIndex: number, limit: number) => {
    setState({
      ...buildInitialState(limit),
      startIndex,
      moveForward: true,
    })
  }, [])

  return {
    ...state,
    hasNext: !!state.nextNextToken,
    hasPrev: state.previousTokens.length > 0,

    changeLimit: async (limit: number) => {
      setState((s) => ({
        ...buildInitialState(limit),
      }))
    },

    changeNextToken: (nextToken: Token) =>
      setState({
        ...state,
        previousTokens: [...previousTokens, nextToken],
        nextToken: nextToken,
      }),
    next: () =>
      setState((state) => ({
        ...state,
        moveForward: true,
        startIndex: state.startIndex + state.limit,
      })),
    prev: () =>
      setState((state) => ({
        ...state,
        moveForward: false,
        startIndex: state.startIndex - state.limit,
      })),

    jumpTo,

    reset: async (limit: number) => {
      setState({
        ...buildInitialState(limit),
        moveForward: true,
        startIndex: 0,
      })
    },
  }
}

export default usePaginate
